// extracted by mini-css-extract-plugin
export default {"footer":"footer_footer__NjMd5","column":"footer_column__4-2GF","title":"footer_title__JaZwJ","logoContainer":"footer_logoContainer__B1dtZ","logo":"footer_logo__ke--D"};